import {Tooltips} from "./admin/Tooltips";
import {WebHelpers, WebHelpersConfig} from "./WebHelpers";
import {Woocommerce} from "./Woocommerce";
import {AdminControls} from "./admin/AdminControls";
import {BrowserWindow} from "./types";


export interface OverseasPaymentsConfig extends WebHelpersConfig {
    // same keys as in php
    /*
    display_currency: string;
    totalCartValue: number;
    ajaxConfirm?: boolean;
    keepTransaction?: boolean; // keep the transaction in mysql so that plugin addons can use them after payment
     */
    cookiePath: string;
    cookieDomain: string;
    orderID: number;
    gateway?: string; // for returning customers

    // localizations
    tr: {
    }
}

export interface OverseasAdminConfig {
    canRequestPayout: boolean;
    minDaysTable: number;

    // localizations
    tr: {
        noGateway: string;
        confirmRemoveGateway: string;
        noPayoutRequestPossible: string;
        confirmPayout: string;
        invalidDateRange: string;
    }
}

export interface AbstractPayment {
    txid: string; // the blockchain transaction ID/hash
    amount: number; // the amount in the website's currency (USD,...)
}

export interface OverseasPaymentsApiRes {
    error: boolean;
    errorMsg: string;
    data: any[];
}

export class OvereasProcessor {
    // TODO separate entryPoints + classes for admin + public code? but tooltips and other admin stuff can be used publicly too (and is quite small)

    public readonly window: BrowserWindow;
    public readonly $: JQueryStatic;
    public readonly woocommerce: Woocommerce;

    protected config: OverseasPaymentsConfig;
    protected adminConfig: OverseasAdminConfig;
    protected webHelpers: WebHelpers;
    protected tooltips: Tooltips; // should be initialized after to have webHelpers instantiated
    protected adminControls: AdminControls;

    constructor(window: BrowserWindow, $: JQueryStatic) {
        this.window = window;
        this.$ = $;
        this.config = this.window['overseasProcessorCfg'] || {};
        this.config.consentCookieName = ""; // we currently don't set any additional cookies (other than WP and WC cookies)
        this.config.confirmCookiesMsg = "";
        this.config.confirmCookiesBtn = "";

        this.webHelpers = new WebHelpers(this.window, this.$, this.config);
        this.tooltips = new Tooltips(this);
        this.adminControls = new AdminControls(this);
        this.woocommerce = new Woocommerce(this, this.webHelpers);
        this.$(this.window.document).ready(($) => {
            this.adminConfig = this.window['overseasAdminCfg'] || {}; // JS bundle is included early on admin page for AdminSettings
            this.webHelpers.checkCookieConsent();
            this.adminControls.init();
        });
    }

    /*
    public static toSatoshis(bch: number) {
        return Math.floor(bch * 100000000);
    }
     */

    public getConfig() {
        return this.config;
    }

    public getAdminConfig() {
        return this.adminConfig;
    }

    public getTooltips() {
        return this.tooltips;
    }

    public getWebHelpers() {
        return this.webHelpers;
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################
}
